// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Hn1d","content":"styles_content__1v9bi"};